import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Aux from "../../hoc/Auxiliary";
import { AlertsTableBig } from "../Alerts/Alerts";
import axiosConfig from "../../axiosConfig";
import RotateLeft from "@material-ui/icons/RotateLeft";
import * as actions from "../../store/actions/index";
import * as alertTypes from "../../shared/language.json";

function OpenAlerts(props) {
  const [openAlerts, setAlerts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);



  const { pointsStore } = props;

  useEffect(() => {
    axiosConfig.get(`/Alarm/AlarmsByStatusIdAndDate?statusId=1`)
      .then((res) => {
        setAlerts(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [, pointsStore]);

  /*const actions = [
    {
      icon: () => <RotateLeft />,
      tooltip: "Όλοι οι Ωφελούμενοι",
      onClick: () => {
        editMapState({
          objectForTableFiltering: {
            beneficiaryId: null,
            alertScore: null,
          },
        });
      },
      isFreeAction: true,
    },
  ];*/

  const columns = [
    {
      field: "id",
      title: "Αρ. Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "beneficiaryId",
      title: "Κωδ. Ωφελούμενου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmSeverity",
      title: "Δείκτης Κινδύνου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmType",
      title: "Τύπος Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "value",
      title: "Τιμή Ειδοποιήσης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "dateCreated",
      title: alertTypes.LABELS.DATEALERT,
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    }
  ];

  return (
    <Aux>
      <AlertsTableBig
        alerts={openAlerts}
        columns={columns}
        title="Ανοιχτές Ειδοποιήσεις"
        isLoading={isLoading}
        localPath='openAlerts'
      />
    </Aux>
  );
}

const mapStateToProps = (state) => {
  return {
    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapState: (mapPayload, editMapPoint, setter) => {
      dispatch(actions.editMapStateAsync(mapPayload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OpenAlerts);